var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDollar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 11.5,
    y: 2,
    width: 2,
    height: 4,
    rx: 1,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 11.5,
    y: 16,
    width: 2,
    height: 5,
    rx: 1,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.493 8.04405C15.2143 7.68939 14.8502 7.40756 14.4005 7.19855C13.9508 6.98955 13.517 6.88505 13.099 6.88505C12.8837 6.88505 12.6652 6.90405 12.4435 6.94205C12.2218 6.98005 12.0223 7.05289 11.845 7.16055C11.6677 7.26822 11.5188 7.40755 11.3985 7.57855C11.2782 7.74956 11.218 7.96805 11.218 8.23405C11.218 8.46206 11.2655 8.65205 11.3605 8.80405C11.4555 8.95606 11.5948 9.08905 11.7785 9.20305C11.9622 9.31706 12.1807 9.42155 12.434 9.51655C12.6873 9.61156 12.9723 9.70972 13.289 9.81105C13.745 9.96306 14.22 10.1309 14.714 10.3146C15.208 10.4982 15.6577 10.7421 16.063 11.0461C16.4683 11.3501 16.804 11.7269 17.07 12.1766C17.336 12.6262 17.469 13.1867 17.469 13.8581C17.469 14.6307 17.3265 15.2989 17.0415 15.8626C16.7565 16.4262 16.3733 16.8917 15.892 17.2591C15.4107 17.6264 14.8597 17.8987 14.239 18.0761C13.6183 18.2534 12.9787 18.3421 12.32 18.3421C11.3573 18.3421 10.4263 18.1742 9.527 17.8386C8.62767 17.5029 7.88034 17.0247 7.285 16.4041L9.413 14.2381C9.74234 14.6434 10.1762 14.9822 10.7145 15.2546C11.2528 15.5269 11.788 15.6631 12.32 15.6631C12.5607 15.6631 12.795 15.6377 13.023 15.5871C13.251 15.5364 13.4505 15.4541 13.6215 15.3401C13.7925 15.2261 13.9287 15.0741 14.03 14.8841C14.1313 14.6941 14.182 14.4661 14.182 14.2001C14.182 13.9467 14.1187 13.7314 13.992 13.5541C13.8653 13.3767 13.6848 13.2152 13.4505 13.0696C13.2162 12.9239 12.9248 12.7909 12.5765 12.6706C12.2282 12.5502 11.8323 12.4204 11.389 12.2811C10.9583 12.1417 10.5372 11.9771 10.1255 11.7871C9.71384 11.5971 9.34651 11.3532 9.0235 11.0556C8.7005 10.7579 8.44084 10.3969 8.2445 9.97255C8.04817 9.54822 7.95 9.03206 7.95 8.42405C7.95 7.67672 8.102 7.03706 8.406 6.50505C8.71001 5.97305 9.109 5.53606 9.603 5.19405C10.097 4.85205 10.6543 4.60189 11.275 4.44355C11.8957 4.28522 12.5227 4.20605 13.156 4.20605C13.916 4.20605 14.6918 4.34539 15.4835 4.62405C16.2752 4.90272 16.9687 5.31439 17.564 5.85905L15.493 8.04405Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDollar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dollar.svg";